<app-progress-indicator [inProgress]="isLoading"></app-progress-indicator>
<div *ngIf="!isLoading">
  <app-astrowetter *ngIf="selectedBundesland === BERLIN"
                   [astrowetter]="rbbAstroWetter"></app-astrowetter>
</div>
